import { Form } from "antd";
import SurveyQuestionHeader from "./components/SurveyQuestionHeader";
import SurveyQuestionContent from "./components/SurveyQuestionContent";
import SurveyQuestionFooterActions from "./components/SurveyQuestionFooterActions";
import styles from "./styles.module.css";
import { useEffect } from "react";

const QuestionBlock = ({ numberPage, question, questionTypes, questions }) => {
  const [form] = Form.useForm();
  const showOptions = [4, 5, 3, 6].includes(question.id_type_question.id);
  const showRating = question.id_type_question.id === 6;
  const showConditional = question.addconditional;

  useEffect(() => {
    form.setFieldsValue({
      question_description: question.question_description,
      id_type_question: question.id_type_question.id,
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [question]);

  return (
    <Form
      initialValues={{
        question_description: question.question_description,
        id_type_question: question.id_type_question.id,
      }}
      form={form}
      layout="vertical"
      className={`${styles["survey-question-block"]} survey-content-card`}
    >
      <SurveyQuestionHeader
        questionTypes={questionTypes}
        question={question}
        numberPage={numberPage}
      />
      <SurveyQuestionContent
        question={question}
        showOptions={showOptions}
        options={question.questionsOptions}
        showRating={showRating}
        showConditional={showConditional}
      />
      <SurveyQuestionFooterActions
        question={question}
        comesFrom={question.order}
        questions={questions}
      />
    </Form>
  );
};

export default QuestionBlock;
